import { FEATURE_FLAGS } from '@constants';

/** The Claim Automation pages shown as tabs on one page, in tab order; a tab with a flag shows only while it is on. */
export const CLAIM_AUTOMATION_TABS: Array<{ label: string; to: string; value: string; flag?: string }> = [
  { label: 'Insights', to: '/admin/claim-automation/insights', value: 'insights' },
  {
    flag: FEATURE_FLAGS.ESCALATION_RECOMMENDATIONS,
    label: 'Control Panel',
    to: '/admin/claim-automation/control-panel',
    value: 'control-panel',
  },
  { label: 'History', to: '/admin/claim-automation/history', value: 'history' },
  { label: 'Feedback', to: '/admin/claim-automation/feedback', value: 'feedback' },
  { label: 'Stores', to: '/admin/claim-automation/stores', value: 'stores' },
  { label: 'Models', to: '/admin/claim-automation/models', value: 'models' },
];

export const CLAIM_AUTOMATION_TAB_PATHS = CLAIM_AUTOMATION_TABS.map(tab => tab.to);

/** The tab strip's height in pixels, its mb-3 margin included, for a page below it that sizes itself to the window. */
export const CLAIM_AUTOMATION_TABS_HEIGHT = 57;
